import { UUID } from 'crypto'
import { LicensesUI, getLicensesTreeTable } from './LicensesUI'
import { PaymentTransactionsUI } from './PaymentTransactionsUI'
import DevelopusTreeTableRowUIModel from '../../../common/ui/treetable/model/DevelopusTreeTableRowUIModel'
import DevelopusTreeTableCellsUIModel from '../../../common/ui/treetable/model/DevelopusTreeTableCellsUIModel'
import DevelopusTreeTableCellUIModel from '../../../common/ui/treetable/model/DevelopusTreeTableCellUIModel'

export type StudentUI = {
  id: UUID
  userId: UUID
  licenses: LicensesUI
  paymentTransactions: PaymentTransactionsUI
  email: string
  firstName: string
  lastName: string
  fatherName: string | undefined
  address: string | undefined
  phoneNumber: string | undefined
  mobileNumber: string | undefined
  birthday: Date
  idNumber: string
  ssrNumber: string
  vatNumber: string
  visuallyImpaired: boolean
}

export const getStudentTreeTable = (
  studentUI: StudentUI,
): DevelopusTreeTableRowUIModel => {
  const licenses = getLicensesTreeTable(studentUI.licenses)

  const cells = new DevelopusTreeTableCellsUIModel([
    new DevelopusTreeTableCellUIModel(studentUI.firstName),
    new DevelopusTreeTableCellUIModel(studentUI.lastName),
    new DevelopusTreeTableCellUIModel(''),
    new DevelopusTreeTableCellUIModel(
      studentUI.paymentTransactions.debts.totalDebt,
    ),
    new DevelopusTreeTableCellUIModel(
      studentUI.paymentTransactions.payments.totalPayment,
    ),
  ])

  return new DevelopusTreeTableRowUIModel(studentUI.id, cells, licenses)
}
